import { gql } from "@apollo/client";

const UPDATE_RESPONSALBE_AREA = gql`
    mutation updateDatosResponsableArea($input: PantallaResponsableAreaInput!, $idGestionReclamo: Int! ){
        updateDatosResponsableArea(input: $input, idGestionReclamo: $idGestionReclamo) {
            idGestionReclamo
        }
    }
`;

export default UPDATE_RESPONSALBE_AREA;